module.exports = __webpack_public_path__ + "img/pic3.08a88ef1.png";